import { useAuthStore, type User } from '../../stores/auth-store';
import { ShieldAlert } from 'lucide-react';

interface RoleRouteProps {
  allowedRoles: readonly User['role'][];
  children: React.ReactNode;
}

export function RoleRoute({ allowedRoles, children }: RoleRouteProps) {
  const user = useAuthStore((s) => s.user);

  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <ShieldAlert size={48} className="mb-4 text-gray-300" />
        <h2 className="text-xl font-semibold text-gray-600">Acceso Denegado</h2>
        <p className="mt-2 text-sm text-gray-400">
          No tienes permisos para acceder a esta sección.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
